<template>
  <div class="room-item-box" :class="{'message-new': room.lastMessage ? room.lastMessage.new : false}">
    <div
      v-if="room.avatar"
      class="room-avatar avatar-single avatar-single--circle avatar-single--small"
      :style="{ 'background-image': `url('${room.avatar}?p=tiny')` }"
    >
      <div v-if="room.profile.is_online" class="avatar-single__online-status d-none d-md-block"></div>
    </div>
    <div class="name-container text-ellipsis">
      <div class="title-container">
        <div class="room-name text-ellipsis">
          {{ room.roomName }}
          <div
            v-if="room.profile.is_online"
            class="state-circle d-inline-block d-md-none"
            :class="{ 'state-online dot-online ml-2': room.profile.is_online }"
          ></div>
        </div>
        <div v-if="room.lastMessage" class="text-date">
          {{ room.lastMessage.timestamp }}
        </div>
      </div>
      <div
        class="text-last"
        v-if="room.lastMessage"
      >
        <span v-if="room.pills" :class="room.pills.type">{{ room.pills.text }}</span>
        <FormatMessage
          :content="room.lastMessage.content"
          :deleted="!!room.lastMessage.deleted"
          :formatLinks="false"
          :textFormatting="true"
          :singleLine="true"
        ></FormatMessage>
      </div>
    </div>
  </div>
</template>

<script>
import FormatMessage from '../../../packages/vue-advanced-chat/src/ChatWindow/FormatMessage';

export default {
  name: 'RoomItem',
  components: { FormatMessage },
  props: {
    room: {},
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  watch: {},
  mounted() {
  }
};
</script>
